
import { mapState } from 'vuex'
import NewsDetailBanner from '~/components/organisms/NewsDetailBanner.vue'
import { API_ROOT_URL } from '~/constants/index'

export default {
  layout: 'user',

  components: { NewsDetailBanner },

  async asyncData({ app, route }) {
    try {
      const { data } = await app.$api.news.show(route.params.id)
      const news = data?.result?.data

      if (news && news.id) {
        const imagePath = `${API_ROOT_URL}${news.image_url}`
        const url = `${process.env.HOME_URL}/news/${news.id}`

        const mutation = app.head.meta.map(i => {
          if (i && i.hid) {
            if (i.hid === 'twitter:title') {
              i.content = news.title
            }
            if (i.hid === 'twitter:image') {
              i.content = imagePath
            }
            if (i.hid === 'twitter:card') {
              i.content = 'summary_large_image'
            }
            if (i.hid === 'twitter:description') {
              i.content = news.description
            }
            if (i.hid === 'og:image') {
              i.content = imagePath
            }
            if (i.hid === 'og:title') {
              i.content = news.title
            }
            if (i.hid === 'og:description') {
              i.content = news.description
            }
            if (i.hid === 'og:url') {
              i.content = url
            }
            if (i.hid === 'description') {
              i.content = news.description
            }
          }
          return i
        })
        const linkRender = app.head.link.map(i => {
          if (i.hid === 'canonical') {
            i.href = url
          }
          return i
        })
        app.head.meta = mutation
        app.head.link = linkRender
        return { news }
      }
    } catch (error) {
      console.log(error)
    }
  },

  async fetch() {
    await this.getNews()
  },

  data() {
    return {
      API_ROOT_URL,
      id: +this.$route.params.id || 0,
      news: {}
    }
  },

  computed: {
    ...mapState({
      loading: 'loading'
    })
  },

  created() {
    this.getNews()
  },

  mounted() {
    this.scrollToTop()
  },

  methods: {
    /**
     * Get news
     */
    async getNews() {
      try {
        this.$store.dispatch('setLoading', true)
        const { data } = await this.$api.news.show(this.id)
        this.news = data?.result?.data
      } catch (_) {
        console.error(_)
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    }
  },

  head() {
    return this.news
      ? {
          title: !this.news.title
            ? 'Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ'
            : this.news.title +
              '｜Two Hearts Christmas Horse Show 2022  Presented by X-mobile｜三木ホースランドパークインドアアリーナ',
          meta: [
            {
              hid: 'og:title',
              name: 'og:title',
              property: 'og:title',
              content: this.news.title
            },
            {
              hid: 'og:type',
              name: 'og:type',
              property: 'og:type',
              content: 'NEWS'
            },
            {
              hid: 'og:url',
              name: 'og:url',
              property: 'og:url',
              content: `${process.env.HOME_URL}/news/${this.news.id}`
            },
            {
              hid: 'og:image',
              name: 'og:image',
              property: 'og:image',
              content: `${API_ROOT_URL}${this.news.image_url}`
            },
            {
              hid: 'og:description',
              name: 'og:description',
              property: 'og:description',
              content: this.news.description
            },
            {
              hid: 'description',
              name: 'description',
              property: 'description',
              content: this.news.description
            },
            {
              hid: 'twitter:title',
              name: 'twitter:title',
              property: 'twitter:title',
              content: this.news.title
            },
            {
              hid: 'twitter:image',
              name: 'twitter:image',
              property: 'twitter:image',
              content: `${API_ROOT_URL}${this.news.image_url}`
            },
            {
              hid: 'twitter:description',
              name: 'twitter:description',
              property: 'twitter:description',
              content: this.news.description
            }
          ],
          link: [
            {
              hid: 'canonical',
              rel: 'canonical',
              href: `${process.env.HOME_URL}/news/${this.news.id}`
            }
          ]
        }
      : ''
  }
}
